import React, { createContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const TestimonialsContext = createContext();

const TestimonialsProvider = ({ children }) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get('/api/testimonials')
      .then((res) => {
        setTestimonials(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <TestimonialsContext.Provider value={{ testimonials, loading, error }}>
      {children}
    </TestimonialsContext.Provider>
  );
};

export { TestimonialsContext, TestimonialsProvider };
